export const STATISTIC_FILL_LT_500 = '#84bdf0';

export const STATISTIC_FILL_LT_2001 = '#FACC15';

export const STATISTIC_FILL_LT_5001 = '#FB923C';

export const STATISTIC_FILL_GTE_5001 = '#92400E';

export function statisticTierHexByTotal(total: number): string {
  const t = Math.max(0, Number.isFinite(total) ? total : 0);
  if (t < 500) return STATISTIC_FILL_LT_500;
  if (t < 2001) return STATISTIC_FILL_LT_2001;
  if (t < 5001) return STATISTIC_FILL_LT_5001;
  return STATISTIC_FILL_GTE_5001;
}

/**
 * Cặp [total, màu hex] cho `interpolate(linear)` của Mapbox circle-color —
 * gradient theo palette cùng bậc như statisticTierHexByTotal / popup TT & tỉnh.
 */
export const STATISTIC_CIRCLE_COLOR_TOTAL_STOPS_FOR_INTERPOLATE = [
  [0, STATISTIC_FILL_LT_500],
  [499, STATISTIC_FILL_LT_500],
  [500, STATISTIC_FILL_LT_2001],
  [2000, STATISTIC_FILL_LT_2001],
  [2001, STATISTIC_FILL_LT_5001],
  [5000, STATISTIC_FILL_LT_5001],
  [5001, STATISTIC_FILL_GTE_5001],
  [75000, STATISTIC_FILL_GTE_5001],
] as const satisfies ReadonlyArray<readonly [number, string]>;

export const STATISTIC_BUBBLE_BORDER_COLOR = '#FFFFFF';

export const STATISTIC_BUBBLE_OPACITY = 1;

export const STATISTIC_BUBBLE_TEXT_COLOR = '#000000';

export const STATISTIC_BUBBLE_TEXT_HALO_COLOR = '#FFFFFF';

export const STATISTIC_BUBBLE_TEXT_HALO_WIDTH = 1.15;

export const STATISTIC_BUBBLE_TEXT_HALO_BLUR = 0.25;
